
import {Component, Mixins, Prop} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import AdresForm from "@/components/forms/AdresForm.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import {MuzekkereAdresBilgileriEntity} from "@/entity/Haciz/MuzekkereAdresBilgileriEntity";

@Component({
  components: {
    FormWrapper,
    AdresForm,
  }
})
export default class MuzekkereAdresBilgileriForm extends Mixins(ObjectInputMixin) {
  @Prop({}) successOnValidate !: any;
  localValue!: MuzekkereAdresBilgileriEntity;
};
